import { FC } from "react";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import {
  initNavigationCopy,
  initNavigationShare,
} from "@/services/navigatorService";
import { getPlaybackUrl } from "@/utils/youtube-utils";
import { formatScore } from "@context/utils";
import { BookmarkRemove, CopyAll, OpenInNew, Share } from "@mui/icons-material";
import { useGameDataContext } from "@context/GameDataContext";
import { gameState } from "@/services/gameState";
import { UpdateActionWithState } from "@/models/socketIo/updateAction";
import { useActionBookmarksContext } from "@context/ActionBookmarksContext";

export interface ContextMenuPosition {
  mouseX: number;
  mouseY: number;
}

const EventCardMenu: FC<{
  contextMenu?: ContextMenuPosition;
  closeContextMenu: () => void;
  action: UpdateActionWithState;
}> = ({ contextMenu, closeContextMenu, action }) => {
  const { game } = useGameDataContext();
  const { removeActionBookmark, actionBookmarks } = useActionBookmarksContext();
  const teams = gameState("teams");
  const firstScoreTime = gameState("timeFirstScoreInMatch");

  const url =
    game?.gameData.youtubeId &&
    game.gameData.gameStartVideoOffset &&
    firstScoreTime &&
    action?.timestamp
      ? getPlaybackUrl(
          game?.gameData.youtubeId,
          action?.timestamp -
            firstScoreTime +
            game.gameData.gameStartVideoOffset -
            10 * 1000,
        )
      : undefined;

  const isFavorite = actionBookmarks?.includes(action.orderRank);

  const scoreText = action
    ? ` | (${action.setNumber}) ${formatScore(action?.score)}`
    : "";

  return url || isFavorite ? (
    <Menu
      open={!!contextMenu}
      onClose={closeContextMenu}
      anchorReference="anchorPosition"
      anchorPosition={
        !!contextMenu
          ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
          : undefined
      }
    >
      {isFavorite ? (
        <MenuItem
          onClick={() => {
            removeActionBookmark(action.orderRank);
            closeContextMenu();
          }}
        >
          <ListItemIcon>
            <BookmarkRemove />
          </ListItemIcon>
          <ListItemText>Lesezeichen entfernen</ListItemText>
        </MenuItem>
      ) : null}
      {url && (
        <>
          <MenuItem
            onClick={async () => {
              await initNavigationShare({
                url,
                title: `${teams.team1.shortName} vs ${teams.team2.shortName}${scoreText}`,
              });
              closeContextMenu();
            }}
          >
            <ListItemIcon>
              <Share />
            </ListItemIcon>
            <ListItemText>Teilen</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={async () => {
              await initNavigationCopy(url);
              closeContextMenu();
            }}
          >
            <ListItemIcon>
              <CopyAll />
            </ListItemIcon>
            <ListItemText>Kopieren</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={async () => {
              window.open(url, "_blank")?.focus();
              closeContextMenu();
            }}
          >
            <ListItemIcon>
              <OpenInNew />
            </ListItemIcon>
            <ListItemText>Öffnen</ListItemText>
          </MenuItem>
        </>
      )}
    </Menu>
  ) : null;
};

export default EventCardMenu;
